"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ExtendedDataset_1 = __importDefault(require("./ExtendedDataset"));
/**
 * Proxy Transactional Dataset is a transactional dataset that does not duplicate
 * the parent dataset, it will dynamically determine the correct return value for
 * methods in real time when the method is called.
 */
var ProxyTransactionalDataset = /** @class */ (function (_super) {
    __extends(ProxyTransactionalDataset, _super);
    /**
     * Constructor
     * @param parentDataset The dataset that will be updated upon commit
     */
    function ProxyTransactionalDataset(parentDataset, datasetFactory) {
        var _this = _super.call(this, datasetFactory.dataset(), datasetFactory) || this;
        _this.parentDataset = parentDataset;
        _this.datasetFactory = datasetFactory;
        _this.datasetChanges = {};
        return _this;
    }
    /**
     * ==================================================================
     * DATASET METHODS
     * ==================================================================
     */
    /**
     * Imports the quads into this dataset.
     * This method differs from Dataset.union in that it adds all quads to the current instance, rather than combining quads and the current instance to create a new instance.
     * @param quads
     * @returns the dataset instance it was called on.
     */
    ProxyTransactionalDataset.prototype.addAll = function (quads) {
        this.updateDatasetChanges({ added: quads });
        return this;
    };
    /**
     * Bulk add and remove triples
     * @param changed
     */
    ProxyTransactionalDataset.prototype.bulk = function (changes) {
        this.updateDatasetChanges(changes);
        return this;
    };
    /**
     *  This method removes the quads in the current instance that match the given arguments. The logic described in Quad Matching is applied for each quad in this dataset to select the quads which will be deleted.
     * @param subject
     * @param predicate
     * @param object
     * @param graph
     * @returns the dataset instance it was called on.
     */
    ProxyTransactionalDataset.prototype.deleteMatches = function (subject, predicate, object, graph) {
        var e_1, _a;
        this.checkIfTransactionCommitted();
        var matching = this.match(subject, predicate, object, graph);
        try {
            for (var matching_1 = __values(matching), matching_1_1 = matching_1.next(); !matching_1_1.done; matching_1_1 = matching_1.next()) {
                var quad = matching_1_1.value;
                this.delete(quad);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (matching_1_1 && !matching_1_1.done && (_a = matching_1.return)) _a.call(matching_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this;
    };
    /**
     * This method returns a new dataset that is comprised of all quads in the current instance matching the given arguments. The logic described in Quad Matching is applied for each quad in this dataset to check if it should be included in the output dataset.
     * @param subject
     * @param predicate
     * @param object
     * @param graph
     * @returns a Dataset with matching triples
     */
    ProxyTransactionalDataset.prototype.match = function (subject, predicate, object, graph) {
        var finalMatch = this.parentDataset.match(subject, predicate, object, graph);
        if (this.datasetChanges.removed) {
            finalMatch = finalMatch.difference(this.datasetChanges.removed);
        }
        if (this.datasetChanges.added) {
            finalMatch = finalMatch.union(this.datasetChanges.added.match(subject, predicate, object, graph));
        }
        return finalMatch;
    };
    Object.defineProperty(ProxyTransactionalDataset.prototype, "size", {
        /**
         * A non-negative integer that specifies the number of quads in the set.
         */
        get: function () {
            var _a, _b;
            return (this.parentDataset.size +
                (((_a = this.datasetChanges.added) === null || _a === void 0 ? void 0 : _a.difference(this.parentDataset).size) || 0) -
                (((_b = this.datasetChanges.removed) === null || _b === void 0 ? void 0 : _b.intersection(this.parentDataset).size) || 0));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds the specified quad to the dataset.
     * Existing quads, as defined in Quad.equals, will be ignored.
     * @param quad
     * @returns the dataset instance it was called on.
     */
    ProxyTransactionalDataset.prototype.add = function (quad) {
        this.updateDatasetChanges({ added: [quad] });
        return this;
    };
    /**
     * Removes the specified quad from the dataset.
     * This method returns the dataset instance it was called on.
     * @param quad
     */
    ProxyTransactionalDataset.prototype.delete = function (quad) {
        this.updateDatasetChanges({ removed: [quad] });
        return this;
    };
    /**
     * Determines whether a dataset includes a certain quad, returning true or false as appropriate.
     * @param quad
     */
    ProxyTransactionalDataset.prototype.has = function (quad) {
        var _a, _b;
        return (!((_a = this.datasetChanges.removed) === null || _a === void 0 ? void 0 : _a.has(quad)) &&
            (((_b = this.datasetChanges.added) === null || _b === void 0 ? void 0 : _b.has(quad)) || this.parentDataset.has(quad)));
    };
    /**
     * Returns an iterator
     */
    ProxyTransactionalDataset.prototype[Symbol.iterator] = function () {
        var _this = this;
        var addedIterator = (this.datasetChanges.added || [])[Symbol.iterator]();
        var addedNext = addedIterator.next();
        var parentIterator = this.parentDataset[Symbol.iterator]();
        var parentNext = parentIterator.next();
        return {
            next: function () {
                if (!addedNext || !addedNext.done) {
                    var toReturn = addedNext;
                    addedNext = addedIterator.next();
                    return toReturn;
                }
                while (!parentNext.done) {
                    var toReturn = parentNext;
                    parentNext = parentIterator.next();
                    if (!(_this.datasetChanges.added &&
                        _this.datasetChanges.added.has(toReturn.value)) &&
                        !(_this.datasetChanges.removed &&
                            _this.datasetChanges.removed.has(toReturn.value))) {
                        return toReturn;
                    }
                }
                return { value: undefined, done: true };
            },
        };
    };
    /**
     * ==================================================================
     * TANSACTIONAL METHODS
     * ==================================================================
     */
    /**
     * Checks if the transaction has been committed and throws an error if it has
     * @param changed
     */
    ProxyTransactionalDataset.prototype.checkIfTransactionCommitted = function () {
        if (this.committedDatasetChanges) {
            throw new Error("Transaction has already committed");
        }
    };
    /**
     * Helper method to update the changes made
     * @param changes
     */
    ProxyTransactionalDataset.prototype.updateDatasetChanges = function (changes) {
        this.checkIfTransactionCommitted();
        // Add added
        if (changes.added) {
            if (this.datasetChanges.added) {
                this.datasetChanges.added.addAll(changes.added);
            }
            else {
                this.datasetChanges.added = this.datasetFactory.dataset(changes.added);
            }
        }
        // Add removed
        if (changes.removed) {
            if (this.datasetChanges.removed) {
                this.datasetChanges.removed.addAll(changes.removed);
            }
            else {
                this.datasetChanges.removed = this.datasetFactory.dataset(changes.removed);
            }
        }
        // Remove duplicates between the two datasets
        if (this.datasetChanges.added && this.datasetChanges.removed) {
            var changesIntersection = this.datasetChanges.added.intersection(this.datasetChanges.removed);
            if (changesIntersection.size > 0) {
                this.datasetChanges.added =
                    this.datasetChanges.added.difference(changesIntersection);
                this.datasetChanges.removed =
                    this.datasetChanges.removed.difference(changesIntersection);
            }
        }
        // Make undefined if size is zero
        if (this.datasetChanges.added && this.datasetChanges.added.size === 0) {
            this.datasetChanges.added = undefined;
        }
        if (this.datasetChanges.removed && this.datasetChanges.removed.size === 0) {
            this.datasetChanges.removed = undefined;
        }
    };
    /**
     * Helper method to update the parent dataset or any other provided dataset
     */
    ProxyTransactionalDataset.prototype.updateParentDataset = function (datasetChanges) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (this.parentDataset.bulk) {
            this.parentDataset.bulk(datasetChanges);
        }
        else {
            if (datasetChanges.added) {
                this.parentDataset.addAll(datasetChanges.added);
            }
            if (datasetChanges.removed) {
                datasetChanges.removed.forEach(function (curQuad) {
                    _this.parentDataset.delete(curQuad);
                });
            }
        }
    };
    /**
     * Commits changes made to the parent dataset
     */
    ProxyTransactionalDataset.prototype.commit = function () {
        var _a, _b;
        this.checkIfTransactionCommitted();
        this.committedDatasetChanges = {
            added: (_a = this.datasetChanges.added) === null || _a === void 0 ? void 0 : _a.difference(this.parentDataset),
            removed: (_b = this.datasetChanges.removed) === null || _b === void 0 ? void 0 : _b.intersection(this.parentDataset),
        };
        this.updateParentDataset(this.committedDatasetChanges);
    };
    /**
     * Rolls back changes made to the parent dataset
     */
    ProxyTransactionalDataset.prototype.rollback = function () {
        if (!this.committedDatasetChanges) {
            throw new Error("Cannot rollback. Transaction has not yet been committed");
        }
        this.updateParentDataset({
            added: this.committedDatasetChanges.removed,
            removed: this.committedDatasetChanges.added,
        });
        this.committedDatasetChanges = undefined;
    };
    /**
     * Starts a new transaction with this transactional dataset as the parent
     * @returns
     */
    ProxyTransactionalDataset.prototype.startTransaction = function () {
        // This is caused by the typings being incorrect for the intersect method
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return new ProxyTransactionalDataset(this, this.datasetFactory);
    };
    ProxyTransactionalDataset.prototype.getChanges = function () {
        return this.datasetChanges;
    };
    return ProxyTransactionalDataset;
}(ExtendedDataset_1.default));
exports.default = ProxyTransactionalDataset;
